import { mq, propToMarginV } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import BreakoutModuleMid from '../BreakoutModuleMid'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;

  ${propToMarginV(`marginV`)}

  > *:first-child {
    z-index: 1;
  }

  > *:last-child {
    top: 50%;
    transform: translateY(-50%);
    z-index: 0;
    position: absolute;
    width: 100%;

    ${mq(`xSmallOnly`)} {
      display: none;
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BreakBehindBreakoutModuleMid = ({ children, marginV, paddingV }) => (
  <Layout className="Breakout" marginV={marginV}>
    <BreakoutModuleMid
      hasBottomBorder={false}
      hasGradient={false}
      paddingV={paddingV}
    >
      {children}
    </BreakoutModuleMid>
    <BreakoutModuleMid hasGradient />
  </Layout>
)

BreakBehindBreakoutModuleMid.propTypes = {
  children: PropTypes.node.isRequired,
  marginV: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  paddingV: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
}

BreakBehindBreakoutModuleMid.defaultProps = {
  marginV: 0,
  paddingV: 0,
}

export default BreakBehindBreakoutModuleMid
